/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';

type EnvironmentSlice = {
    isSpaNavigationEnabled?: boolean;
    featureSwitches: unknown;
    splitTestGroups: object;
    variables: object;
    environmentHash?: string;
    experiments?: unknown[];
    gaTrackingSessionId?: string;
    isHybridAppContextForAndroid?: boolean;
    isHybridAppContextForIos?: boolean;
    isNativeAppWithApplyPaySupport?: boolean;
    isNativeAppWithSwishCallbackSupport?: boolean;
    isNativeAppWithKlarnaSupport?: boolean;
    isHybridAppContext?: boolean;
    appInstanceId?: boolean;
    isIOS?: boolean;
    isNativeAppContext?: boolean;
    isMobileDevice?: boolean;
    isMobileSafari?: boolean;
    version?: string;
};

export const initialState: EnvironmentSlice = {
    featureSwitches: {},
    splitTestGroups: {},
    variables: {}
};

const slice = createSlice({
    name: 'environment',
    initialState,
    reducers: {
        initialize: (_state, { payload }) => {
            return { ...payload };
        },
        setEnvironmentHash: (state, { payload }) => {
            state.environmentHash = payload;
        },
        setIsSpaNavigationEnabled: (state, { payload }) => {
            state.isSpaNavigationEnabled = payload;
        },
        setExperiments: (state, { payload }) => {
            state.experiments = [...(state.experiments ?? []), payload];
        },
        setGATrackingData: (state, { payload }) => {
            state.gaTrackingSessionId = payload.sessionId;
        }
    }
});

export const {
    initialize,
    setEnvironmentHash,
    setIsSpaNavigationEnabled,
    setExperiments,
    setGATrackingData
} = slice.actions;
export const reducer = slice.reducer;
